package com.neurobs.react.semanticui

import com.neurobs.react.ReactUtil
import slinky.core.{FunctionalComponent, Tag, WithAttrs}
import slinky.core.annotations.react
import slinky.core.facade.ReactElement
import slinky.web.html._


object UiHeaderFactory {

  private def TemplateHeader(level: Int, content: ReactElement*)(uiElementModifiers: UiElementModifiers) = {
    val uiClass = uiElementModifiers.formattedClassName("header")
    val styling = uiElementModifiers.createStyle
    level match {
      case 1 => h1(className := uiClass, style := styling)(content:_*)
      case 2 => h2(className := uiClass, style := styling)(content:_*)
      case 3 => h3(className := uiClass, style := styling)(content:_*)
      case 4 => h4(className := uiClass, style := styling)(content:_*)
      case 5 => h5(className := uiClass, style := styling)(content:_*)
      case _ => h6(className := uiClass, style := styling)(content:_*)
    }
  }


  def TextHeader(text: String, level: Int)(implicit uiElementModifiers: UiElementModifiers) = {
    TemplateHeader(level, text)(uiElementModifiers)
  }

}
